angular.module('harriApp')

    .factory('imageCroppingAPI', ["httpHelper", function (httpHelper) {
        var imageCropping = { };

        imageCropping.updateImageCoords = function(data){
            httpHelper.p('update_profile_photo', {
                "image_uuid":data.uuid,
                "rotation" : data.rotation,
                "x1" : data.x1,
                "y1" : data.y1,
                "x2" : data.x2,
                "y2" : data.y2
            });
        };

        return imageCropping;
    }])
    .directive('imageCropping', ["$rootScope", "$timeout", "userMedia", "$filter", "deviceChecker", function ($rootScope, $timeout, userMedia, $filter, deviceChecker) {
        return {
            scope: {

            },
            templateUrl: '../modules/forms/views/imageCropping.html',
            link: function ($scope, $element, attrs) {

//                $('image-cropping').remove();
//                var modal = $('body').append( $element );

                var coverImageConfigs = {
                    minCropBoxWidth: 625,
                    minCropBoxHeight: 300,
                    containerWidth: 830,
                    containerHeight: 600,
                    showPreview: false,
                    aspectRatio: 2.5
                };
                var offerHeaderImageConfigs = {
                    minCropBoxWidth: 240,
                    minCropBoxHeight: 240,
                    containerWidth: 560,
                    containerHeight: 560,
                    showPreview: false
                };
                var profileImageConfigs = {
                    minCropBoxWidth: 240,
                    minCropBoxHeight: 240,
                    containerWidth: 560,
                    containerHeight: 560,
                    showPreview: true,
                    aspectRatio: 1
                };

                var tlImageConfigs = {
                    minCropBoxWidth: 800,
                    minCropBoxHeight: 600,
                    containerWidth: 560,
                    containerHeight: 560,
                    showPreview: true,
                    showIpadPreview: true,
                    aspectRatio: 1.333333333333333
                };

                // viewModeConfigs will contain one of the above configs according to the imageMode if 'cover' or 'profile'
                var viewModeConfigs = {};

                //store degrees as Int (0,1,2,3,-1,-2,-3);
                $scope.opt = {};
                $scope.modalContainerRef = $element.find('.image-cropping-modal');
                $scope.loadingModalRef = $element.find('.image-cropping-modal-loading');
                $scope.cropBoxRef = $element.find('.img-cropper-container>img');


                function gcd (a, b) {
                    return (b == 0) ? a : gcd (b, a%b);
                }


                /**
                 * croppingModal
                 *
                 * @param action
                 */
                $scope.croppingModal = function (action) {
                    $scope.loadingModal('hide');
                    $($scope.modalContainerRef).modal(action);
                };

                $($scope.modalContainerRef).on('hidden.bs.modal', function () {
                    $scope.cropBoxRef.cropper('destroy');
                });

                $scope.rotateFactor = 1;
                // check if the user rotate the image or not
                $scope.imageRotatedByUser = false;
                /**
                 * Rotate
                 *
                 * @param degree
                 * @param direction
                 */
                $scope.rotate = function(degree, direction){
                    $scope.rotateFactor = direction == 'right'? -1: 1;
                    $scope.cropBoxRef.cropper('rotate', degree);
                    $scope.imageRotatedByUser = true;
                };

                /**
                 * Zoom
                 *
                 * @param val
                 */
                $scope.zoom = function(val){
                    $scope.cropBoxRef.cropper('zoom', val);
                };

                /**
                 * Reset
                 *
                 * @param degree
                 */
                $scope.reset = function(degree){
                    $scope.rotateFactor = 1;
                    $scope.cropBoxRef.cropper('reset');
                };

                /**
                 * getCropingData
                 *
                 * @returns {{x1: Number, y1: Number, x2: number, y2: number, rotation: number}}
                 */
                $scope.getCropingData = function () {

                    var cropping_data = $scope.cropBoxRef.cropper('getData', true);

                    var width = Math.floor(cropping_data.width);
                    var height = Math.floor(cropping_data.height);
                    var x = Math.floor(cropping_data.x);
                    var y = Math.floor(cropping_data.y);

                    var data = {
                        'degrees': cropping_data.rotate,
                        // Rotation is no longer used, as rotation is being done from the client side
                        'rotation': ( cropping_data.rotate / 90 ) * -1,
                        'image_uuid': $scope.opt['image_uuid'],
                        'x1': x,
                        'x2': x + width,
                        'y1': y,
                        'y2': y + height
                    };

                    return data;
                };

                /**
                 * Save
                 *
                 * @param degree
                 */
                $scope.save = function(degree){
                    var image = $scope.cropBoxRef.cropper('getDataURL');

                    var data = $scope.getCropingData();

                    rotateBase64Image($(image).attr("src"), data.degrees, function(base64Data) {
                        data.rotation = 0;
                        data.degrees = 0;

                        // Type is image/jpeg because it is a result of a rotate
                        // TODO: Change it to read type from data
                        $scope.opt['croppingModalCallBack'](data, MediaUtils.base64toBlob(base64Data, 'image/jpeg'), $scope.cropBoxRef);
                        $scope.croppingModal('hide');
                        userMedia.clearCache();
                    });

                };

                /**
                 *
                 * @param mode
                 */
                $scope.dragMode = 'crop';
                $scope.setDragMode = function(mode){
                    $timeout(function(){
                        $scope.cropBoxRef.cropper('setDragMode', mode);
                        $scope.dragMode = mode;
                    });
                };

                /**
                 * Coords2Int
                 * convert coordinate float to integer
                 * @param i
                 * @returns {Number}
                 */
                $scope.coords2int = function(i){
                    return  parseInt( Math.floor( i ) );
                };


                /**
                 * Options validate
                 *
                 * @param opt
                 */
                $scope.optValidate = function (opt) {
                    if (!opt.hasOwnProperty('file')) {
                        console.error('Image Cropping Modal: No option specified');
                        return false;
                    }
                    return true;
                };

                /** Events */
                $scope.modalInProgress = false;

                // set image data
                $scope.setImageByData = function (file) {

                    if( !file ){
                        console.warn("Trying to set image data without a file");
                        return;
                    }

                    var reader = new FileReader();
                    reader.onload = function (evt) {

                        var imageMaxSize = 8192;

                        if (deviceChecker.isMobile()) {
                            imageMaxSize = 2048;
                        }

                        loadImage.parseMetaData(
                            file,
                            function (data) {

                                var options = {
                                    maxWidth: imageMaxSize,
                                    maxHeight: imageMaxSize,
                                    canvas: true
                                };

                                if (data.exif) {
                                    options.orientation = data.exif.get('Orientation');
                                }

                                loadImage(
                                    evt.target.result,
                                    function (imgCanvas) {
                                        $scope.initCropperPlugin(imgCanvas.toDataURL('image/jpeg'));
                                    },
                                    options
                                );
                            });

                    };

                    reader.onprogress = function (evt) {
                        //console.log(evt)
                    };

                    reader.readAsDataURL(file);
                };

                /**
                 * initCropper
                 *
                 * @param opt
                 */
                $scope.initCropper = function (opt) {
                    $scope.cropBoxRef.cropper('destroy');

                    var options = {
                        guides: false,
                        aspectRatio: viewModeConfigs['aspectRatio'],
                        preview: ".img-preview",
                        // checkOrientation: false,
                        viewMode: 1,
                        zoomable: $scope.opt['zoomable']? true: false,
                        minCropBoxHeight: opt['minCropBoxHeight'],
                        minCropBoxWidth: opt['minCropBoxWidth']
                    };

                    $scope.cropBoxRef.cropper(options);
                    if (opt['imageMode'] == "brand_offer_header") {
                        $scope.cropBoxRef.cropper('setCropBoxData', opt['crop_dim']);
                    }
                };

                /**
                 * Lodaing Modal Caller
                 * @param mode
                 */
                $scope.loadingModal = function( mode ){
                    if( $scope.loadingModalRef.length ){
                        $scope.loadingModalRef.modal(mode);
                    }
                };



                /**
                 * setCropData
                 *
                 * @param data
                 */
                $scope.setCropData = function(data){
                    $scope.cropBoxRef.cropper({
                        left:data.x1,
                        top:data.y1,
                        width:data.x2,
                        height:data.y2
                    });
                };


                $scope.initCropperPlugin = function(img){

                    $scope.cropBoxRef.cropper('destroy');
                    $scope.croppingModal('show');
                    $element.find(".loader").show();

                    setTimeout(function() {

                        $scope.cropBoxRef.off("load").on("load", function() {

                            var interval = setInterval(function() {
                                var naturalWidth = $scope.cropBoxRef.width();
                                var naturalHeight = $scope.cropBoxRef.height();

                                if (!naturalWidth || !naturalHeight) {
                                    return;
                                }

                                clearInterval(interval);

                                var width = $(window).width() - 30;
                                var height = $(window).height() - 100;

                                width = (width > viewModeConfigs['containerWidth'])? viewModeConfigs['containerWidth']: width;
                                height = (height > viewModeConfigs['containerHeight'])? viewModeConfigs['containerHeight']: height;

                                var criteria = (height < width)? height: width;

                                $scope.opt['minCropBoxWidth'] = parseInt(Math.ceil(( criteria / naturalWidth ) * viewModeConfigs['minCropBoxWidth']));
                                $scope.opt['minCropBoxHeight'] = parseInt(Math.ceil(( criteria / naturalHeight ) * viewModeConfigs['minCropBoxHeight']));

                                $scope.minCropDim = Math.min( $scope.opt['minCropBoxWidth'], $scope.opt['minCropBoxHeight']);

                                $scope.opt['minCropBoxWidth'] = parseInt(Math.ceil($scope.minCropDim * viewModeConfigs['aspectRatio']));
                                $scope.opt['minCropBoxHeight'] = parseInt(Math.ceil($scope.minCropDim));

                                if (naturalWidth >= viewModeConfigs['minCropBoxWidth'] && naturalHeight >= viewModeConfigs['minCropBoxHeight']) {

                                    setTimeout(function() {
                                        $(".img-cropper-container").css("height", criteria + "px");
                                        // for the width attribute in the css with the value of 100% to take precedence for the loading gif to be centered
                                        // $(".img-cropper-container").css("width", criteria + "px");

                                        $element.find(".loader").hide();

                                        $scope.initCropper($scope.opt);
                                    }, 100);

                                }
                                else {
                                    $scope.croppingModal('hide');
                                    $scope.cropBoxRef.cropper('destroy');
                                    hAlert(
                                        $filter("translate")("The photo you uploaded is too small!"),
                                        $filter("translate")("It must be at least") + ' ' + viewModeConfigs['minCropBoxWidth'] + ' ' + $filter("translate")("pixels width and") + ' ' + viewModeConfigs['minCropBoxHeight'] + ' ' + $filter("translate")("pixels height."),
                                        null,
                                        "image-small-alert"
                                    );
                                }

                            }, 100);
                        });


                        if (img) {
                            $scope.cropBoxRef.attr('src', img);
                        }
                        else if ($scope.opt['url']) {
                            $scope.cropBoxRef.attr('src', $scope.opt['url']);
                        }

                    }, 1000);

                    $scope.cropBoxRef.attr('src', '');
                };

                // Remove callbacks on directive destory
                $element.on('$destroy', function() {
                    showCropperLoadingCallback();
                    showCropperCallback();
                });


              //Show Loading
                var showCropperLoadingCallback = $rootScope.$on('showImageCroppingModalLoading', function(){
                    // Loader is no longer a separate modal
                   // $scope.loadingModal('show');
                });


                // Cropping images
                var showCropperCallback = $rootScope.$on('showImageCroppingModal', function (evt, opt) {
                    $scope.opt = opt;
                    if($scope.opt['imageMode'] === 'cover') {
                        viewModeConfigs = coverImageConfigs;
                    }
                    else if($scope.opt['imageMode'] === 'tlipad') {
                        viewModeConfigs = tlImageConfigs;
                    }
                    else if($scope.opt['imageMode']==='brand_offer_header'){
                        viewModeConfigs = offerHeaderImageConfigs
                    }
                    else {
                        viewModeConfigs = profileImageConfigs;
                    }
                    $scope.showPreview = viewModeConfigs['showPreview'];
                    $scope.showIpadPreview = viewModeConfigs['showIpadPreview'];

                    var valid = $scope.optValidate(opt);
                    if (!valid) {
                        return false;
                    }

                    // load image from remote source
                    if (opt['url']) {
                        $scope.initCropperPlugin();
                    }
                    else {
                        $scope.setImageByData(opt['file']);
                    }

                    if( opt['crop_dim'] ){
                        $scope.setCropData(opt['crop_dim']);
                    }
                });

            }
        }
    }]);


//utilities

//resize images based on it's heighest width or height
window.resizeBase64Image = (base64data, newSize, callback) => {
    var image = new Image();

    image.onload = function () {

        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext("2d");


        if (image.height > newSize || image.width > newSize) {
            if (image.height > image.width) {
                //resize the image based on the height
                canvas.height = newSize;
                canvas.width = newSize * (image.width / image.height);
            }
            else {
                //resize the image based on it's width
                canvas.width = newSize;
                canvas.height = newSize * (image.height / image.width);
            }
        }
        else {
            canvas.width = image.width;
            canvas.height = image.height;
        }



        ctx.drawImage(image, 0, 0, canvas.width, canvas.height);

        if (callback) {
            callback({
                base64: canvas.toDataURL("image/jpeg"),
                originalImageWidth: image.width,
                originalImageHeight: image.height,
                targetImageWidth: canvas.width,
                targetImageHeight: canvas.height
            });
        }

        $(canvas).remove();
        $(image).remove();

    };

    image.src = base64data;
}

//RotateImage
function rotateBase64Image(base64data, degrees, callback) {

    var image = new Image();
    image.src = base64data;
    image.onload = function () {

        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext("2d");

        canvas.height = image.height;
        canvas.width = image.width;
        ctx.drawImage(image, 0, 0);


        if (degrees >= 360) degrees = 0;

        if (degrees === 0 || degrees === 180) {
            canvas.width = image.width;
            canvas.height = image.height;
        } else {
            // swap
            canvas.width = image.height;
            canvas.height = image.width;
        }

        ctx.translate(canvas.width / 2, canvas.height / 2);

        ctx.rotate(degrees * Math.PI / 180);
        ctx.drawImage(image, -image.width * 0.5, -image.height * 0.5);

        if (callback) {
            callback(canvas.toDataURL('image/jpeg'));
        }

        $(canvas).remove();
        $(image).remove();
    };
}

//http://stackoverflow.com/questions/934012/get-image-data-in-javascript
function getBase64FromImageUrl(URL, cb) {
    var img = new Image();
    img.src = URL;
    img.onload = function () {


        var canvas = document.createElement("canvas");
        canvas.width =this.width;
        canvas.height =this.height;

        var ctx = canvas.getContext("2d");
        ctx.drawImage(this, 0, 0);


        var dataURL = canvas.toDataURL("image/png");

        cb( dataURL.replace(/^data:image\/(png|jpg);base64,/, "") )
    }
}


